import React from "react";
import Representation from './Representation';

const TextArea = (props) => {
  return <Representation
    {...props}
  />
}

export default TextArea;